import { render, staticRenderFns } from "./PosterVertical.vue?vue&type=template&id=0344e466"
import script from "./PosterVertical.vue?vue&type=script&lang=js"
export * from "./PosterVertical.vue?vue&type=script&lang=js"
import style0 from "./PosterVertical.vue?vue&type=style&index=0&id=0344e466&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports